module.exports = __webpack_public_path__ + "static/img/logo-1x.ad1b5276.png";